module.exports = __webpack_public_path__ + "static/img/game-head-yyhyddp.a007574.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/game/game-head-yyhyddp.png
// module id = FEmD
// module chunks = 1